var methods={

    errorPrint(errorMessage){//PRINTS ERROR IN RED COLOR
        var error = "%c" + errorMessage;
        console.log(error, 'color:#ff0000')
    },
    isRTL () {
      return document.documentElement.getAttribute('dir') === 'rtl' || document.body.getAttribute('dir') === 'rtl'
    },
    numberWithCommas(x) {
        return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    randomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
    },
    toCapitalizedWords(name){
      var words = name.match(/[A-Za-z][a-z]*/g) || [];
      return words.map(this.capitalize).join(" ");
    },
    capitalize(s){
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },

    //Load Filter Options
    loadFilterOptions () {
      let filterList = [
        {url:'/api/master/pdc', variable:'pdc', instruction:'data = data.map(x=>x.pdc)'},
        {url:'/api/master/region', variable:'region', instruction:'data = data.map(x=>x.region)'},
        {url:'/api/master/dso-location', variable:'dealer'},
        {url:'/api/master/vehicle-type', variable:'type', instruction:'data = data.map(x=>x.type)'},
        {url:null, variable:'month'},
        {url:null, variable:'year'}
      ]
  
      let monthName = ['January' , 'February' , 'March' , 'April', 'May', 'June' , 'July', 'August', 'September', 'October' , 'November', 'December']
      var year = []
  
      for (var i = 0 ; i < filterList.length; i++) {
        let currentFilter = filterList[i];
        let designatedVar = currentFilter.variable;
  
        //if filter exist, skip
        if(this.$store.state.filterOptions[designatedVar] != null) continue;
  
        if (designatedVar == 'month') {//month
          this.$store.dispatch('setMonth', monthName.map((mon, i) => ({value:i+1, name:mon})))
        } else if (designatedVar == 'year') {//year
          for (var j = new Date().getFullYear(); j >= 2019; j--) year.push(j.toString())
          this.$store.dispatch('setYear', year)
        } else {//rest of filter
          this.$http.get(`${currentFilter.url}?pagination=false&by=name&order=ASC`)
          .then((resp) => {
            var data = resp.data.data;

            //If additional command is needed, just read the instructions
            if (currentFilter.instruction != null) eval(currentFilter.instruction);
  
            this.$store.dispatch(`set${this.capitalize(designatedVar)}`, data)
          })
          .catch(err => console.log(err))
        }
      }//FOR LOOP ENDS 
      
    },
}

export default methods;